import { scrollAnimation } from './function/scroll-animation.js';
const tile = require('./function/tile.js');
const slick = require('/assets/js/slick/slick.js');
import '/assets/js/common.js';
import '/assets/js/slick/slick.css';
import '/assets/css/_common.scss';
import '/assets/css/archive-news.scss';


// ===========================================
// スクロールストップイベントを追加
// ===========================================
(function(){
  let newEvent = new $.Event("scrollstop"),
      timer;

  function newEventTrigger(){

    if (timer) clearTimeout(timer);

    timer = setTimeout(function(){
      $(window).trigger(newEvent)
    }, 200);
  }

  $(window).on("scroll", newEventTrigger);
})();

// ===========================================
// 年選択のインタラクション
// ===========================================
$(function () {
  function openClose( head, body ) {
    head.css({ pointerEvents: 'none' });

    head.toggleClass('open')
    body.slideToggle(300);

    setTimeout(function () {
      head.css({ pointerEvents: 'auto' });
    }, 300);
  }

  function txtChange( currentYear, head ) {
    let currentYearTxt;

    if(
      currentYear === 'all-year' ||
      currentYear === undefined
    ) {
      currentYearTxt = 'ARCHIVE';

      setTimeout(function () {
        $('label[for="all-year"]').css({ display: 'none' });
      }, 350);
    } else {
      currentYearTxt = currentYear + '年';

      setTimeout(function () {
        $('label[for="all-year"]').css({ display: 'block' });
      }, 350);
    }

    head.html( currentYearTxt + '<span class="yearNavHead__icon"></span>' );
  }

  $('.yearNav').each(function(){
    const head = $(this).find('.yearNavHead'),
          body = $(this).find('.yearNavBody'),
          input = $('input[name="currentYear"]');
    let currentYear = $('input[name="currentYear"]:checked').val();

    txtChange( currentYear, head );

    head.on('click', function(){
      openClose( head, body );
    });

    input.on('change', function(){
      currentYear = $('input[name="currentYear"]:checked').val();

      txtChange( currentYear, head );
      openClose( head, body );
    });
  });
});


// ===========================================
// 記事をajaxで読みこみ
// ===========================================
$(function(){
  const params = new URL(window.location.href).searchParams;
  let category,
      year,
      paged = 1,
      beforePaged,
      scroll = $(window).scrollTop(),
      loadPoint = $('.newsListArea').offset().top + $('.newsListArea').outerHeight(),
      noMoreArticles = false;

  // ajaxで記事を取得する処理の関数。
  function ajaxLoad( category, year, paged ) {
    // function.phpに情報（カテゴリー、年）を送信し、出力する記事の情報を取得する。
    $.ajax({
      type: 'POST',
      url: ajaxurl,
      data: {
        'action' : 'ajax_get_new_posts',
        'category' : category,
        'year' : year,
        'paged' : paged,
      },

      // 送信が成功した場合に実行される関数。
      success: function( response ){
        // phpから送られてきた配列をjsonに変換。
        let jsonData = JSON.parse( response );

        // jsonをもとに、出力するhtmlを生成。
        let result_html = '<ul class="c-newsList">';
            jsonData.forEach(function(data){
              let cats = '';

              data['terms'].forEach(function(term){
                cats = cats +
                          '<span class="c-newsListCat__icon" data-cat="' + term['name'] + '" >' +
                            term['name'] +
                          '</span>';
              });

              result_html = result_html +
                '<li class="c-newsList__item">' +
                  '<a href="' + data['permalink'] + '" class="c-transitionIconWrapper">' +
                    '<div class="c-newsListDate c-english">' +
                      data['post_date'] +
                    '</div>' +
                    '<div class="c-newsListCat">' + cats + '</div>' +
                    '<div class="c-newsListTtl">' +
                      '<h3 class="c-newsListTtl__ttl">' + data['post_title'] + '</h3>' +
                      '<span class="c-transitionIcon c-transitionIcon--newsList"></span>' +
                    '</div>' +
                  '</a>' +
                '</li>';
            });
            result_html = result_html + '</ul>'

        // ページ送りをした場合は、出力するhtmlを末端に追加し、
        // 絞り込み条件を変更した場合は、まっさらな状態でhtmlを出力する。
        if( paged > beforePaged ) {
          // ページ送りをした場合。
          $('.newsListArea .newsListAreaInner').append( result_html );

          setTimeout(function () {
            $('.newsListAreaInner .c-newsList:not(.active)').addClass('active');
          }, 50);
        } else {
          // 絞り込み条件を変更した場合。
          $('.newsListAreaInner .c-newsList.active').removeClass('active');

          setTimeout(function () {
            $('.newsListArea .newsListAreaInner').html( result_html );
          }, 300);

          setTimeout(function () {
            $('.newsListAreaInner .c-newsList:not(.active)').addClass('active');
          }, 350);
        }
        setTimeout(function () {
          $('.newsListAreaInner .c-newsList:not(.active)').each(function(){
            $(this).addClass('active');
          });
        }, 1300);
        beforePaged = paged;

        if( response === '[]' ) {
          noMoreArticles = true;
        }
      }
    });
    return false;
  }

  // 絞り込みを実行した際のインタラクション
  $('input[name="currentCat"], input[name="currentYear"]').on( 'change', function(){
    paged = 1;
    noMoreArticles = false

    if( $('input[name="currentCat"]:checked').val() === 'cat-all' ) {
      category = 'undefined';
    } else {
      category = $('input[name="currentCat"]:checked').val();
    }

    if( $('input[name="currentYear"]:checked').val() === 'all-year' ) {
      year = 'undefined';
    } else {
      year = $('input[name="currentYear"]:checked').val();
    }

    ajaxLoad( category, year, paged );
  });

  // ページ訪問時、自動的に絞り込みを動作させる
  if( params.get('current-cat') ) {
    $('input[value="' + params.get('current-cat') + '"]').click();
  } else {
    $('input[value="cat-all"]').click();
  }

  // ページの最下部までスクロールした際のインタラクション
  $(window).on("scrollstop", function(){
    if( noMoreArticles === false ) {
      scroll = $(window).scrollTop();
      loadPoint = $('.newsListArea').offset().top + $('.newsListArea').outerHeight() - $(window).height() + $(window).height() / 4;

      if( scroll > loadPoint ) {
        paged++;

        ajaxLoad( category, year, paged );
      }
    }
  });
});